/**
 * Build a full exercises-catalog-v2 PUT body from a detail/list exercise object.
 * Keeps muscle groups and metadata intact when only videos/images change.
 */
export function buildExerciseCatalogUpdatePayload(exercise, overrides = {}) {
  if (!exercise?.id) {
    throw new Error("Exercise id is required");
  }

  const mainMuscleGroups =
    overrides.mainMuscleGroups ??
    exercise.mainMuscleGroups ??
    (Array.isArray(exercise.muscleGroups) ? exercise.muscleGroups : []);

  const secondaryMuscleGroups =
    overrides.secondaryMuscleGroups ?? exercise.secondaryMuscleGroups ?? [];

  return {
    id: exercise.id,
    name: exercise.name,
    description: exercise.description ?? "",
    instructions: exercise.instructions ?? "",
    difficulty: exercise.difficulty || "beginner",
    icon: exercise.icon ?? "",
    isCustom: exercise.isCustom ?? true,
    mainMuscleGroups,
    secondaryMuscleGroups,
    equipment: overrides.equipment ?? exercise.equipment ?? [],
    images: overrides.images ?? exercise.images ?? [],
    videos: overrides.videos ?? exercise.videos ?? [],
  };
}

/**
 * Remove a video URL from an exercise, tolerating minor URL formatting differences.
 */
export function removeVideoFromList(videos, videoURL) {
  const target = normalizeVideoUrl(videoURL);
  return (videos || []).filter((video) => normalizeVideoUrl(video) !== target);
}

function normalizeVideoUrl(url) {
  return String(url || "")
    .trim()
    .replace(/\/$/, "");
}
